import { z } from "zod";

import { FormNames } from "../utils/form/form-names.util.ts";

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, { message: "Unos email adrese je obavezan" })
    .email({ message: "Nevalidan format email adrese" }),
  password: z
    .string({ message: "Unos šifre je obavezan" })
    .min(5, { message: "Šifra mora imati minimalno 5 karaktera" }),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const loginFormFieldNames: FormNames<LoginFormData> = {
  email: "email",
  password: "password",
};
